export var createVerificationURL = function (baseUrl, redirect) {
    var result = baseUrl;
    var tokenAssignation = 'workEmailVerifyToken=';
    if (redirect) {
        result += '?redirect=' + redirect + '&' + tokenAssignation;
    }
    else {
        result += '?' + tokenAssignation;
    }
    return result;
};
//# sourceMappingURL=verificationUrl.js.map